/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AbstractService, ServiceCallType } from '@iotize/tap';

export class JvmService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get JVM reserved code size
   *
   * LWM2M path: /1024//73
   *
   * @tapVersion(">=1.90")
   * @return
   */
  getCodeSize(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getCodeSizeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//73
   *
   * @tapVersion(">=1.90")
   * @return call options
   */
  getCodeSizeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCodeSize };

    return callOptions;
  }

  /**
   * Write JVM reserved code size
   *
   * LWM2M path: /1024//73
   *
   * @tapVersion(">=1.90")
   * @param value input
   * @return
   */
  putCodeSize(
    /*
     *
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putCodeSizeCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//73
   *
   * @tapVersion(">=1.90")
   * @param value input
   * @return call options
   */
  putCodeSizeCall(
    /*
     *
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCodeSize };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Append JVM code. If body length is 0, it will clear code stored in Tap.
   *
   * LWM2M path: /1024//74
   *
   * @tapVersion(">=1.90")
   * @param value input
   * @return
   */
  appendCode(
    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.appendCodeCall(value));
  }

  appendCodeAppendCalls(
    /*
     *
     */
    value: Uint8Array,
    chunkSize?: number,
  ) {
    return this.serviceCallRunner.createAppendCalls(
      this.appendCodeCall(value),
      chunkSize,
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//74
   *
   * @tapVersion(">=1.90")
   * @param value input
   * @return call options
   */
  appendCodeCall(
    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.appendCode };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Clear code stored in Tap.
   *
   * LWM2M path: /1024//74
   *
   * @tapVersion(">=1.90")
   * @return
   */
  clearCode(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.clearCodeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//74
   *
   * @tapVersion(">=1.90")
   * @return call options
   */
  clearCodeCall(): ServiceCallType {
    const callOptions = { ...this.resources.clearCode };

    return callOptions;
  }

  /**
   * Get user id that gives rights to the JVM code
   *
   * LWM2M path: /1024//66
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getProfileId(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getProfileIdCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//66
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getProfileIdCall(): ServiceCallType {
    const callOptions = { ...this.resources.getProfileId };

    return callOptions;
  }

  /**
   * Write user id that gives right to the JVM code
   *
   * LWM2M path: /1024//66
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putProfileId(
    /*
     *
     */
    key: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putProfileIdCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//66
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putProfileIdCall(
    /*
     *
     */
    key: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putProfileId };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Read and then clear JVM log
   *
   * LWM2M path: /1024//120
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getLogAndClear(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getLogAndClearCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//120
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getLogAndClearCall(): ServiceCallType {
    const callOptions = { ...this.resources.getLogAndClear };

    return callOptions;
  }

  /**
   * Clear JVM log
   *
   * LWM2M path: /1024//120
   *
   * @tapVersion(">=2.11")
   * @return
   */
  clearLog(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.clearLogCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//120
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  clearLogCall(): ServiceCallType {
    const callOptions = { ...this.resources.clearLog };

    return callOptions;
  }

  /**
   * Read JVM log
   *
   * LWM2M path: /1024//121
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getLog(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getLogCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//121
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getLogCall(): ServiceCallType {
    const callOptions = { ...this.resources.getLog };

    return callOptions;
  }

  /**
   * Write JVM log
   *
   * LWM2M path: /1024//121
   *
   * @tapVersion(">=2.11")
   * @param value input
   * @return
   */
  putLog(
    /*
     *
     */
    value: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putLogCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//121
   *
   * @tapVersion(">=2.11")
   * @param value input
   * @return call options
   */
  putLogCall(
    /*
     *
     */
    value: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putLog };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get jvm last error code
   *
   * LWM2M path: /3//14
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getErrorCode(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getErrorCodeCall());
  }

  /**
   *
   *
   * LWM2M path: /3//14
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getErrorCodeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getErrorCode };

    return callOptions;
  }

  /**
   * Set jvm last error code
   *
   * LWM2M path: /3//14
   *
   * @tapVersion(">=2.11")
   * @param errorCode input
   * @return
   */
  postErrorCode(
    /*
     *
     */
    errorCode: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postErrorCodeCall(errorCode));
  }

  /**
   *
   *
   * LWM2M path: /3//14
   *
   * @tapVersion(">=2.11")
   * @param errorCode input
   * @return call options
   */
  postErrorCodeCall(
    /*
     *
     */
    errorCode: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postErrorCode };

    callOptions.body = errorCode;

    return callOptions;
  }
}
